<template>
  <div class="slide" id="slide_final" v-if="isVisibleSlide('final')">
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="content-wrapper">
              <p>Next - we’re backing the Bakers, Food and Allied Workers’ Union (BFAWU) to push for better treatment and safe working conditions for workers in the fast food industry.</p>
              <p class="highlight">Could you donate a few pounds to support this crucial campaign?</p>
              <div class="buttons-container">
                <button
                  class="btn btn-light red"
                  @click="donate(2); analytics('donate', 'clicked donate £2');"
                >Donate £2</button>
                <button
                  class="btn btn-light red"
                  @click="donate(3); analytics('donate', 'clicked donate £3');"
                >Donate £3</button>
                <button
                  class="btn btn-light red"
                  @click="donate(5); analytics('donate', 'clicked donate £5');"
                >Donate £5</button>
              </div>
              <button
                class="btn btn-skip"
                @click="gotoSlide('final2'); analytics('donate', 'clicked no');"
              >Not right now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Final",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {};
  },
  methods: {
    donate: function(amt) {
      //var url  = "https://mcstrike.raisely.com/"+amt;
      var url = "https://mcstrike.raisely.com/?amount=" + amt;
      window.open(url, "_blank");
      this.gotoSlide("final2");
    }
  }
};
</script>

<style scoped lang="scss">
.slide-content {
  .container {
    box-shadow: 0px 0px 10px rgba(70, 70, 70, 0.1);
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
    text-align: center;
    .content-wrapper {
      margin: 140px auto;
      max-width: 650px;
      @media only screen and (max-width: 1100px) {
        margin: 70px auto;
      }
      @media only screen and (max-width: 768px) {
        margin: 30px auto;
      }
    }
  }
  p {
    font-size: 17px;
    &.highlight {
      color: #cd171e;
      font-weight: 600;
      margin-top: 20px;
      font-size: 20px;
      @media only screen and (max-width: 768px) {
        font-size: 16px;
      }
    }
    @media only screen and (max-width: 768px) {
      text-align: center;
      font-size: 14px;
    }
  }
}
.buttons-container {
  margin: 30px auto;
  background: #f6f6f6;
  padding: 25px;
  max-width: 560px;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
  button {
    display: inline-block;
    margin: 0 20px 0 0;
    font-size: 18px;
    min-width: 150px;
    font-weight: normal;
    padding: 17px 20px;
    @media only screen and (max-width: 768px) {
      margin: 15px 0 15px 0;
      width: 100%;
    }
  }
}
</style>